import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { TRANSITION_DELAY, TRANSITION_STYLES } from './constants';

import * as styles from './NotificationWrapper.css';

interface INotificationWrapperProps extends React.PropsWithChildren {
  in?: boolean;
  onCloseRequest?(): void;
  timeout?: number;
}

export const NotificationWrapper: React.FC<INotificationWrapperProps> = ({
  children,
  in: inProp,
  onCloseRequest,
  timeout,
}) => {
  const closeRequestRef = React.useRef(onCloseRequest);

  React.useEffect(() => {
    let closeTimeout: number;

    if (timeout) {
      closeTimeout = setTimeout(() => {
        if (closeRequestRef.current) {
          closeRequestRef.current();
        }
      }, timeout) as unknown as number;
    }

    return () => {
      clearTimeout(closeTimeout);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    closeRequestRef.current = onCloseRequest;
  }, [onCloseRequest]);

  return (
    <CSSTransition in={inProp} classNames={TRANSITION_STYLES} timeout={TRANSITION_DELAY} unmountOnExit>
      <div className={styles['notification']}>{children}</div>
    </CSSTransition>
  );
};
